module.exports = __webpack_public_path__ + "static/media/20160512_185226.c586237c.jpg";